/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import ajaxBank from "../../../util/remote/ajaxBank";
import { Link, useParams, useSearchParams } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AppContainer from "../../Structure/AppContainer";
import Pagination from "../../Common/Pagination";
import Loader from "../../Common/Loader";

const PocketMoneyBalancesStatement=(props)=>{
    const [studentTransactions, setStudentTransactions] = useState([]);
    const [transactionPage, setTransactionPage] = useState(1);
    const [transactionMeta, setTransactionMeta] = useState([]);
    const [transactionLoading, setTransactionLoading] = useState(false);
    const {id} = useParams();
    const [searchParams] = useSearchParams();
    const username = searchParams.get('username');
    const balance = searchParams.get('balance');
    const user = searchParams.get('user');

    const getStudentTransactions = async (currentPage) => {
        setTransactionLoading(true);
        const server_response = await ajaxBank.fetchUserPocketMoneyTransactions(currentPage, id);
       
        setTransactionLoading(false);
        if (server_response.status === "OK") {
          setTransactionMeta(server_response.details.meta.totalPages);
          if (currentPage === 1) {
            setStudentTransactions(server_response.details.data || []);
        } else {
            setStudentTransactions((prevTransactions) => [
                ...prevTransactions,
                ...server_response.details.data,
            ]);
        }
        } else {
          setStudentTransactions([]);
        }
    };

    const handlePagination = (newPage) => {
        if (newPage > 0 && newPage <= transactionMeta) {
          setTransactionPage(newPage);
        }
    };

    const exportToPDF = () => {
        const pdf = new jsPDF("p", "pt", "a4");

        const heading = "POCKET MONEY STATEMENT";
        const pageWidth = pdf.internal.pageSize.getWidth();
        const textWidth = pdf.getTextWidth(heading);
        const xPosition = (pageWidth - textWidth) / 2; // Calculate center position
        pdf.text(heading, xPosition, 30); // Add text at the top
      
        // Columns and data for the transaction table
        const columns = ["Invoice Date", "Transaction Reference", "Description", "In", "Out"];
        const data = studentTransactions.map(item => [
          item.created_at?.when,
          item.transaction_number,
          item.description,
          item.account === "Deposit"? item.amount : "0",
          item.account === "Deposit"? "0" : item.amount,

        ]);
      
        // Combine student info into a single row
        const studentInfo = [
          ["Student Name: " + user, "Buzz Number: " + username, "Pocket Money Balance: " + balance]
        ];
      
        // First, add a row for the title with 2 rows of headers
        let yPosition = 20;  // Starting Y position
        
        pdf.autoTable({ // Title row, spanning across all columns
          body: [["", "", "", ""]], // Empty body row for spacing
          startY: yPosition,
          theme: 'plain',
          margin: { top: 5 },
          styles: { halign: "center", fontSize: 14, fontStyle: "bold" }, // Customize styles for title row
        });
      
        // Add the student info row (with colSpan)
        pdf.autoTable({
          head: [["", "", ""]], // Empty row to align with student info
          body: studentInfo, // Combined row with labels and data in the same cells
          startY: yPosition + 20,  // Adjust to position below the title row
          theme: 'plain',
          margin: { top: 5 },
          styles: { fontSize: 10 },
          columnStyles: {
            0: { fontStyle: "bold" },  // Bold the first column (labels)
          },
        });
      
        // Now add the actual transaction table
        pdf.autoTable({
          head: [columns], // Column headers for the transaction table
          body: data,  // Data for the table
          startY: yPosition + 70,  // Start the table below the student info
        });
        
        // Save the PDF
        pdf.save("student_pocket_money_statement.pdf");
      };

    useEffect(() => {
        if (id) {
          getStudentTransactions(transactionPage, id);
        }
      }, [transactionPage, id]);

    
    

    return(
        <AppContainer title={"Pocket Money Statement"} >
            <div className="row">
           
            <Link to={'/pocket-money-balances'} className="btn btn-info ml-4 mb-2 text-white"><i class="fas fa-arrow-left mr-1"></i>Student List</Link>
        <div className="col-lg-12">
          <div className="card custom-card">
            <div className="card-body map-card">
              <div class="heading-layout1 mg-b-25">
                
                <div class="dropdown">
                   <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link>
                </div>
              </div>


              <div className="border-top mt-3"></div>
              <div className="table-responsive">
                {transactionLoading ? (
                    <Loader />
                ) : (
                        <table className="table display data-table text-nowrap">
                            <thead>
                                <tr>
                                    <th scope="col" colSpan="5" style={{ textAlign: "center" }}>POCKET MONEY STATEMENT</th>
                                </tr>
                                <tr>
                                    <th scope="col" colSpan="2">Student Name :  {user}</th>
                                    <th scope="col" colSpan="1">Buzz Number : {username}</th>
                                    <th scope="col" colSpan="2">Pocket Money Balance : {balance}</th>

                                </tr>
                               
                                <tr>
                                    <th scope="col">Invoice Date</th>
                                    <th scope="col">Transaction Reference</th>
                                    <th scope="col">Description</th>
                                    <th scope="col"> In</th>
                                    <th scope="col"> Out</th>
                                
                                </tr>
                            </thead>
                            <tbody>
                                {studentTransactions.length > 0 ? (
                                    studentTransactions.map((item, index) => (
                                    <tr key={index}>
                                        

                                        <td>{item.created_at?.when} </td>
                                        
                                        <td>{item.transaction_number}</td>
                                        <td>{item.description}</td>

                                        <td>{item.account === "Deposit"? item.amount : "0"}</td>
                                        <td>{item.account === "Deposit"? "0" : item.amount}</td>

                                    </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center" }}>
                                            No transactions yet.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                )}
            </div>
              <Pagination currentPage={transactionPage} totalPages={transactionMeta} onPageChange={handlePagination}/>
            </div>
          </div>
        </div>
      </div> 
     

      
          

      </AppContainer>
        
    )
}

export default PocketMoneyBalancesStatement
